import { createSlice } from "@reduxjs/toolkit";
import { fetchShareCartId } from "./share-cart.thunks";
import { ActionStatus } from "../../common/constants/action-status";
import { defaultApiState } from "../../common/constants/api-constants"

/*----- CREATE INITIAL STATE ------*/
export const defaultShareCartState = {
  ...defaultApiState,
  data:{
    cartId:''
  }
}

/*----- CREATE STORE SLICE ------*/

export const shareCartSlice = createSlice({
  name:"sharecart",
  initialState: defaultShareCartState,
  reducers:{},
  extraReducers(builder) {
    builder
    .addCase(fetchShareCartId.pending, (state) => {
      state.status = ActionStatus.loading
    })
    .addCase(fetchShareCartId.fulfilled, (state, action) => {
      state.status = ActionStatus.succeeded
      state.data = action.payload;
    })
    .addCase(fetchShareCartId.rejected, (state, action) => {
      state.status = ActionStatus.failed
      state.error = action.error.message || ''
    })
  }
});

/*----- CREATE REDUCER ------*/

export const shareCartReducer = shareCartSlice.reducer;



